/**
 * Created by ivo on 28.01.17.
 */

import _ from 'underscore';
import t from '../trans';
import Log from '../Log';
import AppServices from '../AppServices';
import {RestAction} from "./RestAction";

/**
 * Implements standard REST CRUD source for stores based by BaseListStore.
 *
 */
class RestSource {
    /**
     *
     * @param {BaseRestActions} actionClass Alt.js action class for handling actions for this resource
     * @param {string} resource Resource name
     */
    constructor(actionClass, resource) {
        this.restApi = null;
        this.actionClass = actionClass;
        this.resource = resource;
    }

    getRestApi() {
        if (this.restApi == null) this.restApi = AppServices.getRestApi();
        return this.restApi;
    }

    getExportedMethods() {
        return {'actionStart': this.actionStart.bind(this)};
    }

    actionStart() {
        return {
            remote: function(state, action) {
                // Call appropriate action method:
                if (!action) return null;
                return this.callActionMethod(action);
            }.bind(this),

            local: function() {
                return null;
            },

            success: this.actionClass.actionSuccess,
            error: this.actionClass.actionFailed
        };
    }

    /**
     *
     * @param {RestAction} action
     * @returns {*}
     */
    callActionMethod(action) {
        if (this[action.method]) return this[action.method](action);
        else {
            Log.error("Internal error: RestSource does not have method: " + action.method);
            throw t("Internal error");
        }
    }

    /**
     * Performs object list reading from REST API
     * @param {RestAction} action
     * @returns {*}
     */
    getCollection(action) {
        return this.getRestApi().setRequestId(action.actionId).getCollection(this.resource, action.filter,
            action.sort, action.firstRecord, action.pageSize, this.getHeaders(action));
    }

    /**
     *  Performs record reading
     * @param {RestAction} action
     * @returns {*}
     */
    get(action) {
        return this.getRestApi().setRequestId(action.actionId).get(this.resource, action.id, this.getHeaders(action));
    }

    /**
     *  Performs record insertion
     * @param {RestAction} action
     * @returns {*}
     */
    post(action) {
        return this.getRestApi().setRequestId(action.actionId).post(this.resource, action.resource, this.getHeaders(action));
    }

    /**
     *  Performs record update
     * @param {RestAction} action
     * @returns {*}
     */
    put(action) {
        return this.getRestApi().setRequestId(action.actionId).put(this.resource, action.id, action.resource, this.getHeaders(action));
    }

    /**
     *  Performs record deletion
     * @param {RestAction} action
     * @returns {*}
     */
    del(action) {
        return this.getRestApi().setRequestId(action.actionId).del(this.resource, action.id, this.getHeaders(action));
    }

    /**
     * Set headers based by request
     * @private
     * @param action
     * @returns {{}}
     */
    getHeaders(action) {
        let headers = {};
        if (action.authToken != null) {
            if (action.authToken === "") headers = {"X-Authorization": ""};
            else headers = {"X-Authorization": "Bearer " + action.authToken};
        }
        return headers;
    }
}

export default RestSource;
